import React from 'react';
import PropTypes from 'prop-types';

import { MINDBODY, BOOKER, OTHER, SCIBLER } from '../../assets/BookingSoftwares';

export default function WellnessSoftware({
  bookingSoftware,
  softwares,
  swSetupStatus,
  dashboard,
  onMindBodyEditClick,
  auth,
}) {
  return (
    <div className="summary-item">
      <div className="summary-item__detail">
        <div className="summary-item__heading">{bookingSoftware.label || 'Software'}</div>
        <div className="summary-item__value">{softwares.info.STUDIO_NAME}{softwares.info?.brand ? ' (Brand)' : '(Location)'}</div>
        <div className="summary-item__value">{softwares.info.STUDIO_LOCATION}</div>
        <div className="summary-item__value">{softwares.info?.form?.referral_email ? 'Referral Email: ' + softwares.info.form.referral_email : ''}</div>
        <div className="summary-item__value">
          {bookingSoftware.value === BOOKER ? `Client ID: ${softwares.bookerClientId}` : undefined}
          {(bookingSoftware.value === MINDBODY || bookingSoftware.value === SCIBLER || !softwares?.is_truelark) ? `Studio ID: ${softwares?.info?.STUDIO_ID || auth.studio_id}` : undefined}
          {bookingSoftware.value === OTHER ? `Username: ${softwares.otherUsername}` : undefined}
          &nbsp;
          {bookingSoftware.value !== SCIBLER && (
            <>{dashboard.tasksStatus.bookingSW_connect !== 'completed' ? (
              <span className="message--error">Not Authorized</span>
            ) : (
              <span className="message--success">Authorized</span>
            )}</>)}
        </div>
        {bookingSoftware.value !== SCIBLER && (
          <div className="summary-item__value">
            <span className="message-welcome">{swSetupStatus}</span>
          </div>)}
      </div>
      <div className="summary-item__actions">
        <button className="btn btn--primary btn--sm" onClick={onMindBodyEditClick}>
          UPDATE
        </button>
      </div>
    </div>
  );
}

WellnessSoftware.defaultProps = {
  onMindBodyEditClick: () => { },
  bookingSoftware: {},
};

WellnessSoftware.propTypes = {
  onMindBodyEditClick: PropTypes.func,
  bookingSoftware: PropTypes.shape({}),
  swSetupStatus: PropTypes.string.isRequired,
  softwares: PropTypes.shape({
    status: PropTypes.string,
    isApproved: PropTypes.bool,
    selectedSoftware: PropTypes.string,
    studioId: PropTypes.string,
    bookerClientId: PropTypes.string,
    otherUsername: PropTypes.string,
    info: PropTypes.shape({
      STUDIO_LOCATION: PropTypes.string,
      STUDIO_NAME: PropTypes.string,
      isLoaded: PropTypes.bool,
    }),
  }).isRequired,
  dashboard: PropTypes.shape({
    tasksStatus: PropTypes.shape({
      call_forwarding: PropTypes.string,
      bookingSW_connect: PropTypes.string,
    }),
  }).isRequired,
};
